// extracted by mini-css-extract-plugin
module.exports = {"featureList":"_FeatureList-styles-module--featureList--3Hhan","primaryButton":"_FeatureList-styles-module--primaryButton--1-ntw","badge":"_FeatureList-styles-module--badge--3Q7N6"};